export default "__VITE_ASSET__BjsZG6gc__"